<template>
  <div class="oauth-cover">
    <div>One moment please..</div>
  </div>
</template>
<script>
export default {
  mounted() {
    const query = this.$route.query;
    switch (this.$route.params.provider) {
      case "facebook": {
        const state = JSON.parse(query.state);
        if (query.code) {
          window.opener.postMessage(
            {
              type: "oauth",
              provider: this.$route.params.provider,
              token: query.code
            },
            window.location.origin + state.pathname
          );
        } else {
          window.opener.postMessage(
            {
              type: "oauth",
              provider: this.$route.params.provider,
              error: "Something went wrong."
            },
            window.location.origin + state.pathname
          );
        }
        break;
      }
      case "twitter": {
        if (query.oauth_token) {
          window.opener.postMessage(
            {
              type: "oauth",
              provider: this.$route.params.provider,
              token: query.oauth_token,
              verifier: query.oauth_verifier
            },
            "*"
          );
        } else {
          window.opener.postMessage(
            {
              type: "oauth",
              provider: this.$route.params.provider,
              error: "Something went wrong."
            },
            "*"
          );
        }
        break;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.oauth-cover {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>